import React from "react";
import { useNavigate } from "react-router-dom";
import UsersList from "../../Modals/usersList";
import {
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
  Checkbox,
  FormControlLabel,
  Input,
  CardMedia,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ViewPromotion = () => {
  const navigate = useNavigate();
  const [openUserModal, setOpenUserModal] = React.useState(false);
  const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>([]);
  const usersList = [
    {
      id: "1",
      label: "John Doe",
      avatar: "/static/images/user_placeholder.png",
    },
    {
      id: "2",
      label: "Jane Smith",
      avatar: "/static/images/user_placeholder.png",
    },
    {
      id: "3",
      label: "Michael Scott",
      avatar: "/static/images/user_placeholder.png",
    },
    {
      id: "4",
      label: "Pam Beesly",
      avatar: "/static/images/user_placeholder.png",
    },
  ];
  const handleOpenAudience = () => {
    setSelectedUserIds(usersList.map((u) => u.id));
    setOpenUserModal(true);
  };
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  return (
    <>
      <div className="main_title">
        <h1>Promotion Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-categories")}>
            Manage Product Categories
          </button>{" "}
          - Product Category Detail
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Category Detail" {...a11yProps(0)} />
              <Tab label="Subcategories" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards view_page">
        <CustomTabPanel value={valueTabs} index={0}>
          {/* Category Info (matches Add Category fields) */}
          <div className="section_title">
            <h2>Category Info</h2>
          </div>
          <div className="gap_p">
            <div className="vew_img v2 no_radius w_100">
              <h6>Image</h6>
              <figure>
                <img src="/static/images/placeholder.png" alt="img" />
              </figure>
            </div>
            <div className="w_33">
              <h6>Title</h6>
              <p>Electronics</p>
            </div>
            <div className="w_33">
              <h6>Service Fee</h6>
              <p>10.00</p>
            </div>
            <div className="w_33">
              <h6>Featured</h6>
              <p>
                <Chip size="small" label="Featured" color="success" />
              </p>
            </div>
            <div className="w_100">
              <h6>Description</h6>
              <p>
                Category description goes here. Provide a concise summary for
                this category.
              </p>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="table_header">
            <div className="left_s">
              <div className="section_title">
                <h2>Subcategories</h2>
              </div>
            </div>
            <div className="right_s">
              <AddSubcategory />
            </div>
          </div>
          <SubcategoryTable />
        </CustomTabPanel>
      </div>
      <UsersList
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        setOpen={setOpenUserModal}
        userIds={selectedUserIds}
        usersList={usersList}
      />
    </>
  );
};

export default ViewPromotion;

// Subcategory management components (local to this page)
const SubcategoryTable = () => {
  const [rows, setRows] = React.useState([
    {
      id: "SUB-001",
      name: "Mobiles",
      description: "Smartphones and accessories",
      featured: true,
      logo: "/static/images/placeholder.png",
      created: "01-Mar-2025",
    },
    {
      id: "SUB-002",
      name: "Laptops",
      description: "Laptops and ultrabooks",
      featured: false,
      logo: "/static/images/placeholder.png",
      created: "05-Mar-2025",
    },
  ] as Array<{ id: string; name: string; description: string; featured: boolean; logo: string; created: string }>);
  const [editOpen, setEditOpen] = React.useState(false);
  const [editId, setEditId] = React.useState<string | null>(null);
  const [editName, setEditName] = React.useState("");
  const [editDescription, setEditDescription] = React.useState("");
  const [editFeatured, setEditFeatured] = React.useState(false);
  const [editLogo, setEditLogo] = React.useState<string>("");

  const startEdit = (id: string) => {
    const row = rows.find((r) => r.id === id);
    if (!row) return;
    setEditId(id);
    setEditName(row.name);
    setEditDescription(row.description);
    setEditFeatured(row.featured);
    setEditLogo(row.logo);
    setEditOpen(true);
  };
  const saveEdit = () => {
    if (!editId) return;
    setRows((prev) =>
      prev.map((r) =>
        r.id === editId
          ? {
              ...r,
              name: editName.trim() || r.name,
              description: editDescription,
              featured: editFeatured,
              logo: editLogo || r.logo,
            }
          : r
      )
    );
    setEditOpen(false);
    setEditId(null);
  };
  const remove = (id: string) =>
    setRows((prev) => prev.filter((r) => r.id !== id));

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow hover>
              {/* <TableCell>ID</TableCell> */}
              <TableCell>Image</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Featured</TableCell>
              <TableCell>Created</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow hover key={r.id}>
                {/* <TableCell>{r.id}</TableCell> */}
                <TableCell>
                  <img
                    src={r.logo}
                    alt={r.name}
                    style={{
                      height: 40,
                      width: 60,
                      objectFit: "cover",
                      borderRadius: 4,
                    }}
                  />
                </TableCell>
                <TableCell>{r.name}</TableCell>
                <TableCell>{r.description}</TableCell>
                <TableCell>
                  {r.featured ? (
                    <Chip size="small" color="success" label="Yes" />
                  ) : (
                    <Chip size="small" label="No" />
                  )}
                </TableCell>
                <TableCell>{r.created}</TableCell>
                <TableCell>
                  <div className="table_actions v2">
                    <IconButton onClick={() => startEdit(r.id)}>
                      <img src="/static/images/edit2_icon.svg" alt="Edit" />
                    </IconButton>
                    <IconButton onClick={() => remove(r.id)}>
                      <img src="/static/images/trash2_icon.svg" alt="Delete" />
                    </IconButton>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog
        open={editOpen}
        onClose={() => setEditOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Subcategory</DialogTitle>
        <DialogContent>
          <div className="gap_p" style={{ marginTop: 8 }}>
            <div className="control_group w_33">
              <label htmlFor="subcat_logo_edit">Image</label>
              {editLogo ? (
                <div className="upload_image v2 no_radius">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia
                        component="img"
                        image={editLogo}
                        alt="Subcategory logo"
                      />
                    </figure>
                    <IconButton
                      aria-label="Remove uploaded image"
                      onClick={() => setEditLogo("")}
                      size="small"
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                </div>
              ) : (
                <label
                  className="upload_image v2 no_radius"
                  htmlFor="subcat_logo_edit"
                >
                  <Input
                    sx={{ display: "none" }}
                    id="subcat_logo_edit"
                    type="file"
                    inputProps={{ accept: "image/png,image/jpeg" }}
                    onChange={(e: any) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        const url = URL.createObjectURL(file);
                        setEditLogo(url);
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/placeholder.png"
                        alt="placeholder"
                      />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="Upload" />
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>
            <div className="control_group w_100">
              <label htmlFor="subcat_name">Name</label>
              <TextField
                id="subcat_name"
                fullWidth
                value={editName}
                onChange={(e) => setEditName(e.target.value)}
                placeholder="Subcategory name"
              />
            </div>
            <div className="control_group w_100">
              <label htmlFor="subcat_desc">Description</label>
              <TextField
                id="subcat_desc"
                fullWidth
                multiline
                minRows={3}
                value={editDescription}
                onChange={(e) => setEditDescription(e.target.value)}
                placeholder="Description"
              />
            </div>
            <div className="control_group w_33">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={editFeatured}
                    onChange={(e) => setEditFeatured(e.target.checked)}
                  />
                }
                label="Mark as Featured"
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditOpen(false)}>Cancel</Button>
          <Button className="btn btn_primary" onClick={saveEdit}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const AddSubcategory = () => {
  const [open, setOpen] = React.useState(false);
  const [name, setName] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [featured, setFeatured] = React.useState(false);
  const [logo, setLogo] = React.useState<string>("");
  const [rows, setRows] = React.useState<
    Array<{
      id: string;
      name: string;
      description: string;
      featured: boolean;
      logo: string;
      created: string;
    }>
  >([]);
  return (
    <>
      <Button className="btn btn_primary" onClick={() => setOpen(true)}>
        Add Subcategory
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add Subcategory</DialogTitle>
        <DialogContent>
          <div className="gap_p" style={{ marginTop: 8 }}>
            <div className="control_group w_100">
              <div className="control_group w_33">
                <label htmlFor="add_subcat_logo">Image</label>
                {logo ? (
                  <div className="upload_image v2 no_radius">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia
                          component="img"
                          image={logo}
                          alt="Subcategory logo"
                        />
                      </figure>
                      <IconButton
                        aria-label="Remove uploaded image"
                        onClick={() => setLogo("")}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  </div>
                ) : (
                  <label
                    className="upload_image v2 no_radius"
                    htmlFor="add_subcat_logo"
                  >
                    <Input
                      sx={{ display: "none" }}
                      id="add_subcat_logo"
                      type="file"
                      inputProps={{ accept: "image/png,image/jpeg" }}
                      onChange={(e: any) => {
                        const file = e.target.files?.[0];
                        if (file) {
                          const url = URL.createObjectURL(file);
                          setLogo(url);
                        }
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/placeholder.png"
                          alt="placeholder"
                        />
                        <span className="upload_img_icon">
                          <img
                            src="/static/images/edit2_icon.svg"
                            alt="Upload"
                          />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
              <label htmlFor="add_subcat_name">Name</label>
              <TextField
                id="add_subcat_name"
                fullWidth
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Subcategory name"
              />
            </div>
            <div className="control_group w_100">
              <label htmlFor="add_subcat_desc">Description</label>
              <TextField
                id="add_subcat_desc"
                fullWidth
                multiline
                minRows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Description"
              />
            </div>
            <div className="control_group w_33">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={featured}
                    onChange={(e) => setFeatured(e.target.checked)}
                  />
                }
                label="Mark as Featured"
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button className="btn btn_primary" onClick={() => setOpen(false)}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
